module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-3.7d3dee2f.jpg";